import React, { useContext, useEffect, useState } from 'react';
import { usePage } from '../contexts/pageContext';
import constantes from '../resources/constantes.json';
import { getLogo64Object } from '../utils/logosUtils';

const LogosContext = React.createContext();

const LogosProvider = ({ children }) => {
  const page = usePage();
  const [state, setState] = useState({
    logos: new Map()
  });
  const tabla = page?.data?.camaras?.[0]?.partotabla;
  const circuscripcion = page?.data?.camaras?.[0]?.cir


  function areMapsEqual(map1, map2) {
    if (map1.size !== map2.size) {
      return false;
    }

    for (const [key, value] of map1) {
      if (!map2.has(key) || map2.get(key) !== value) {
        return false;
      }
    }

    return true;
  }

  useEffect(() => {
    function getLogosTabla() {
      if (tabla && circuscripcion && Number(circuscripcion) <= 1) {

        const promises = tabla.map(({ act }) => {
          const imgUrl = `${constantes.rutas.logo}${act.codpar.padStart(4, '0')}`

          if (!state.logos.get(imgUrl)) {
            return getLogo64Object(imgUrl)
          }
        })

        const auxLogos = new Map(state.logos);

        Promise.all(promises).then((values) => {
          values.forEach(({ url, base64data }) => {
            auxLogos.set(url, base64data)
          })
        }).catch();

        if (!areMapsEqual(auxLogos, state.logos)) {
          setState({ logos: auxLogos })
        }

      };
    }
    getLogosTabla();

  }, [circuscripcion, state.logos, tabla])


  return (
    <LogosContext.Provider value={{ state, setState }}>
      {children}
    </LogosContext.Provider>
  );
};

export default LogosProvider;

export const useLogosContext = () => useContext(LogosContext).state;
export const useSetLogosContext = () => useContext(LogosContext).setState;
